export default __webpack_public_path__ + "static/media/download-dark.a3a4faa0.svg";